@if (!loading()) {
  <section class="content">
    @if (subjectName()) {
      <lyceo-subject-icon
        [subjectName]="subjectName()"
        [shape]="subjectIconShape"
      />
    }
    <h4>
      {{ subjectName() | overviewSubjectName }} <br />
      <span class="label-medium">{{ bookName() }}</span>
    </h4>
  </section>
  @if (showProgress()) {
    <lyceo-progress-bar
      [total]="totalChapters()"
      [progress]="completedChapters()"
      [showText]="true"
      [loading]="false"
    />
  }
} @else {
  <section class="content">
    <lyceo-skeleton-text class="empty-icon" />
    <lyceo-skeleton-text />
  </section>
  <section>
    <lyceo-progress-bar [loading]="true" />
  </section>
}
